"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SessionsListView = void 0;
const lodash_1 = require("lodash"); // Ensure lodash is installed
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const react_window_1 = require("react-window");
const react_window_infinite_loader_1 = __importDefault(require("react-window-infinite-loader"));
const toggleIconBlue_svg_1 = __importDefault(require("../../../assets/icons/toggleIconBlue.svg"));
const hooks_1 = require("../../../store/hooks");
const mapSlice_1 = require("../../../store/mapSlice");
const getSessionListExportLimit_1 = require("../../../utils/getSessionListExportLimit");
const cookieManager_1 = require("../../../utils/cookieManager");
const useAutoDismissAlert_1 = require("../../../utils/useAutoDismissAlert");
const AlertComponent_1 = require("../Popups/AlertComponent");
const ExportButtonComponent_1 = __importDefault(require("./ExportButtonComponent"));
const SessionListTile_1 = require("./SessionsListTile/SessionListTile");
const S = __importStar(require("./SessionsListView.style"));
const Row = react_1.default.memo(({ index, style, data, }) => {
    const { sessions, handleClick, handleMouseEnter, handleMouseLeave, isIndoor, isDormant, } = data;
    const session = sessions[index];
    if (!session) {
        return null;
    }
    return (react_1.default.createElement("div", { style: style },
        react_1.default.createElement("div", { style: { padding: isIndoor ? "0.1rem 0" : "0.5rem 0" } },
            react_1.default.createElement(SessionListTile_1.SessionsListTile, { id: session.id, sessionName: session.sessionName, sensorName: session.sensorName, averageValue: session.averageValue, startTime: session.startTime, endTime: session.endTime, streamId: session.streamId, onClick: handleClick, onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave, isIndoor: isIndoor, isDormant: isDormant }))));
});
const SessionsListView = ({ sessions, sessionType, sensorName, onCellClick, onCellMouseEnter, onCellMouseLeave, onScrollEnd, fetchableSessionsCount, isIndoor, isDormant, }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const results = sessions.length;
    const sessionsIds = sessions.map((session) => session.id);
    const exportButtonRef = (0, react_1.useRef)(null);
    const sessionListRef = (0, react_1.useRef)(null);
    const [buttonPosition, setButtonPosition] = (0, react_1.useState)({
        top: 0,
        left: 0,
    });
    const [showExportPopup, setShowExportPopup] = (0, react_1.useState)(false);
    const [showAlert, setShowAlert] = (0, react_1.useState)(false);
    const [alertMessage, setAlertMessage] = (0, react_1.useState)("");
    const listContainerRef = (0, react_1.useRef)(null);
    const [listDimensions, setListDimensions] = (0, react_1.useState)({ width: 0, height: 0 });
    const [dimensionsReady, setDimensionsReady] = (0, react_1.useState)(false);
    const sessionsExportLimit = (0, react_1.useMemo)(() => (0, getSessionListExportLimit_1.getSessionListExportLimit)(sessionType, sensorName), [sessionType, sensorName]);
    const NO_SESSIONS = sessionsIds.length === 0;
    const EXCEEDS_LIMIT = sessionsIds.length > sessionsExportLimit;
    const popupTopOffset = NO_SESSIONS ? -13 : -50;
    const dispatch = (0, hooks_1.useAppDispatch)();
    const sessionsListExpanded = (0, hooks_1.useAppSelector)(mapSlice_1.selectSessionsListExpanded);
    const infiniteLoaderRef = (0, react_1.useRef)(null);
    const initialScrollOffset = (0, react_1.useMemo)(() => {
        if (sessionsListExpanded && cookieManager_1.CookieManager.arePreferenceCookiesAllowed()) {
            const savedScrollPosition = localStorage.getItem("sessionsListScrollPosition");
            return savedScrollPosition ? Number(savedScrollPosition) : 0;
        }
        return 0;
    }, [sessionsListExpanded]);
    const saveScrollPosition = (0, react_1.useCallback)((0, lodash_1.debounce)((scrollOffset) => {
        if (sessionsListExpanded && cookieManager_1.CookieManager.arePreferenceCookiesAllowed()) {
            localStorage.setItem("sessionsListScrollPosition", String(scrollOffset));
        }
    }, 200), [sessionsListExpanded]);
    (0, react_1.useEffect)(() => {
        if (infiniteLoaderRef.current && sessions.length) {
            infiniteLoaderRef.current.resetloadMoreItemsCache();
        }
    }, [sessions]);
    (0, react_1.useLayoutEffect)(() => {
        function updateSize() {
            if (listContainerRef.current) {
                const newDimensions = {
                    width: listContainerRef.current.offsetWidth,
                    height: listContainerRef.current.offsetHeight,
                };
                setListDimensions(newDimensions);
                // Only set dimensions ready if we have valid dimensions
                if (newDimensions.width > 0 && newDimensions.height > 0) {
                    setDimensionsReady(true);
                }
            }
        }
        window.addEventListener("resize", updateSize);
        updateSize();
        return () => window.removeEventListener("resize", updateSize);
    }, []);
    const updateButtonPosition = (0, react_1.useCallback)(() => {
        var _a;
        const rect = (_a = exportButtonRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
        if (rect) {
            setButtonPosition({
                top: rect.top + window.scrollY,
                left: rect.left + window.scrollX,
            });
        }
    }, [exportButtonRef, sessions]);
    const debouncedUpdateButtonPosition = (0, react_1.useCallback)((0, lodash_1.debounce)(updateButtonPosition, 100), [updateButtonPosition]);
    (0, react_1.useLayoutEffect)(() => {
        updateButtonPosition();
        const handleResize = () => {
            debouncedUpdateButtonPosition();
        };
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
            debouncedUpdateButtonPosition.cancel();
        };
    }, [updateButtonPosition, debouncedUpdateButtonPosition]);
    const itemCount = fetchableSessionsCount > sessions.length
        ? sessions.length + 1
        : sessions.length;
    const loadMoreItems = onScrollEnd;
    const isItemLoaded = (index) => !fetchableSessionsCount || index < sessions.length;
    const itemSize = isIndoor ? 100 : 130;
    const listHeight = dimensionsReady ? listDimensions.height : 400;
    const listWidth = dimensionsReady ? listDimensions.width : 230;
    const handleClick = (0, react_1.useCallback)((id, streamId) => {
        if (onCellClick) {
            onCellClick(id, streamId);
        }
    }, [onCellClick]);
    const handleMouseEnter = (0, react_1.useCallback)((id) => {
        if (onCellMouseEnter) {
            onCellMouseEnter(id);
        }
    }, [onCellMouseEnter]);
    const handleMouseLeave = (0, react_1.useCallback)(() => {
        if (onCellMouseLeave) {
            onCellMouseLeave();
        }
    }, [onCellMouseLeave]);
    const itemData = (0, react_1.useMemo)(() => ({
        sessions,
        handleClick,
        handleMouseEnter,
        handleMouseLeave,
        isIndoor,
        isDormant,
    }), [
        sessions,
        handleClick,
        handleMouseEnter,
        handleMouseLeave,
        isIndoor,
        isDormant,
    ]);
    (0, react_1.useEffect)(() => {
        // Clear saved scroll position when sessions list is collapsed
        if (!sessionsListExpanded && cookieManager_1.CookieManager.arePreferenceCookiesAllowed()) {
            localStorage.removeItem("sessionsListScrollPosition");
        }
    }, [sessionsListExpanded]);
    // Force re-render when dimensions become ready
    (0, react_1.useEffect)(() => {
        if (dimensionsReady && sessions.length > 0) {
            // Small delay to ensure the container is fully rendered
            const timer = setTimeout(() => {
                if (infiniteLoaderRef.current) {
                    infiniteLoaderRef.current.resetloadMoreItemsCache();
                }
            }, 100);
            return () => clearTimeout(timer);
        }
    }, [dimensionsReady, sessions.length]);
    const calculatePopupLeftPosition = () => {
        return `${buttonPosition.left - 185}px`;
    };
    const handleExportClick = () => {
        if (NO_SESSIONS) {
            setAlertMessage(t("exportDataModal.noResultsMessage"));
            setShowAlert(true);
        }
        else if (EXCEEDS_LIMIT) {
            setAlertMessage(t("exportDataModal.sessionLimitMessage", {
                limit: sessionsExportLimit,
            }));
            setShowAlert(true);
        }
        else {
            setShowExportPopup(true);
        }
    };
    const handleExpandClick = () => {
        dispatch((0, mapSlice_1.setSessionsListExpanded)(!sessionsListExpanded));
    };
    (0, useAutoDismissAlert_1.useAutoDismissAlert)(showAlert, setShowAlert);
    return (react_1.default.createElement(S.SessionListViewStyle, null,
        react_1.default.createElement(S.SessionInfoTile, null,
            react_1.default.createElement(S.SessionListInfoContainer, null,
                react_1.default.createElement(S.ExpandButton, { onClick: handleExpandClick },
                    react_1.default.createElement(S.RotatedIcon, { src: toggleIconBlue_svg_1.default, alt: t("headerToggle.arrowIcon"), "$rotated": !sessionsListExpanded }),
                    react_1.default.createElement(S.SessionListTitle, null, t("map.listSessions")),
                    react_1.default.createElement(S.SessionListTitle, null, t("map.results", { results, fetchableSessionsCount })))),
            react_1.default.createElement(ExportButtonComponent_1.default, { NO_SESSIONS: NO_SESSIONS, EXCEEDS_LIMIT: EXCEEDS_LIMIT, sessionsIds: sessionsIds, sensorName: sensorName, showExportPopup: showExportPopup, handleExportClick: handleExportClick, exportButtonRef: exportButtonRef })),
        sessionsListExpanded && (react_1.default.createElement(S.SessionListContainer, { ref: listContainerRef }, sessions.length > 0 && (react_1.default.createElement(react_window_infinite_loader_1.default, { ref: infiniteLoaderRef, isItemLoaded: isItemLoaded, itemCount: itemCount, loadMoreItems: loadMoreItems }, ({ onItemsRendered, ref }) => (react_1.default.createElement(react_window_1.FixedSizeList, { key: `${listHeight}-${listWidth}-${itemSize}`, className: "List", height: listHeight, itemCount: itemCount, itemSize: itemSize, width: listWidth, itemData: itemData, onScroll: (scrollArgs) => saveScrollPosition(scrollArgs.scrollOffset), ref: ref, initialScrollOffset: initialScrollOffset, onItemsRendered: onItemsRendered }, Row)))))),
        showAlert && (react_1.default.createElement(AlertComponent_1.AlertPopup, { open: showAlert, message: alertMessage, top: buttonPosition.top + popupTopOffset, left: calculatePopupLeftPosition() }))));
};
exports.SessionsListView = SessionsListView;
